/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nftLucky.vue?vue&type=template&id=95766f42&scoped=true"
import script from "./nftLucky.vue?vue&type=script&lang=js"
export * from "./nftLucky.vue?vue&type=script&lang=js"
import style0 from "./nftLucky.vue?vue&type=style&index=0&id=95766f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95766f42",
  null
  
)

export default component.exports